import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=f4c32b42&"
import script from "./DropdownMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports